// Mock data para o site institucional DRSUPORTI

export const companyInfo = {
  name: "DRSUPORTI",
  fullName: "DRSUPORTI SOLUÇÕES EM TI",
  slogan: "Sua tecnologia em boas mãos, sempre.",
  description: "Empresa de Soluções em TI que atua com suporte técnico, cloud, segurança da informação, infraestrutura de redes e consultoria em melhoria de processos.",
  coverage: ["MA", "PI", "SP"],
  whatsapp: "5511999999999",
  whatsappMessage: "Olá! Gostaria de falar com um especialista em TI.",
  email: "contato@drsuporti.com.br",
  phone: "(11) 9999-9999",
  clientAreaLinks: [
    { label: "Download de acesso remoto", href: "" },
    { label: "HelpCentral", href: "" }
  ]
};

export const services = [
  {
    id: 1,
    title: "Outsourcing de TI",
    description: "Terceirize a gestão de TI da sua empresa com profissionais especializados. Reduza custos, aumente a eficiência e foque no seu core business.",
    icon: "Users",
    features: ["Gestão completa de infraestrutura", "Equipe dedicada", "SLA garantido", "Relatórios mensais"]
  },
  {
    id: 2,
    title: "Infraestrutura e Redes",
    description: "Projetamos, implementamos e mantemos redes corporativas seguras e de alta performance para sua empresa operar sem interrupções.",
    icon: "Network",
    features: ["Cabeamento estruturado", "Switches e roteadores", "Wi-Fi corporativo", "Monitoramento 24/7"]
  },
  {
    id: 3,
    title: "Segurança da Informação",
    description: "Proteja seus dados e sistemas contra ameaças cibernéticas com soluções completas de segurança da informação.",
    icon: "Shield",
    features: ["Firewall e antivírus", "Backup em nuvem", "Políticas de segurança", "Análise de vulnerabilidades"]
  },
  {
    id: 4,
    title: "Cloud Computing",
    description: "Migre para a nuvem com segurança e escale sua infraestrutura conforme a demanda do seu negócio.",
    icon: "Cloud",
    features: ["Migração para nuvem", "Azure, AWS, Google Cloud", "Gestão de custos", "Alta disponibilidade"]
  },
  {
    id: 5,
    title: "Consultoria e Melhoria de Processos",
    description: "Avaliamos seu ambiente de TI e propomos melhorias estratégicas para otimizar processos e aumentar a produtividade.",
    icon: "LineChart",
    features: ["Diagnóstico de TI", "Planejamento estratégico", "Otimização de processos", "Governança de TI"]
  }
];

export const differentials = [
  {
    id: 1,
    title: "Atendimento Rápido",
    description: "Tempo de resposta ágil para garantir que sua operação nunca pare. Suporte presencial e remoto quando você precisar.",
    icon: "Zap"
  },
  {
    id: 2,
    title: "Experiência de Mercado",
    description: "Anos de experiência atendendo empresas de diversos segmentos. Conhecemos os desafios do seu negócio.",
    icon: "Award"
  },
  {
    id: 3,
    title: "Suporte Especializado",
    description: "Equipe técnica certificada e em constante atualização para oferecer as melhores soluções do mercado.",
    icon: "HeadphonesIcon"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Carlos Silva",
    role: "Diretor de Operações",
    company: "Empresa ABC",
    content: "A DRSUPORTI transformou nossa infraestrutura de TI. O atendimento é excepcional e os problemas são resolvidos rapidamente."
  },
  {
    id: 2,
    name: "Ana Rodrigues",
    role: "Gerente de TI",
    company: "Indústria XYZ",
    content: "Parceria de anos que só se fortalece. A equipe é altamente qualificada e sempre propõe soluções inovadoras."
  },
  {
    id: 3,
    name: "Roberto Mendes",
    role: "CEO",
    company: "Startup Tech",
    content: "Migramos toda nossa operação para a nuvem com a DRSUPORTI. Processo tranquilo e sem nenhuma interrupção."
  }
];

export const blogPosts = [
  {
    id: 1,
    title: "5 Sinais de que sua empresa precisa de suporte de TI profissional",
    excerpt: "Descubra os principais indicadores de que é hora de contar com especialistas em TI para manter sua operação funcionando.",
    date: "2025-08-10",
    category: "Suporte TI",
    image: "https://images.pexels.com/photos/442150/pexels-photo-442150.jpeg"
  },
  {
    id: 2,
    title: "Cloud Computing: Por que sua empresa deve migrar agora",
    excerpt: "Conheça os benefícios da computação em nuvem e entenda como ela pode transformar seu negócio.",
    date: "2025-08-05",
    category: "Cloud",
    image: "https://images.pexels.com/photos/1148820/pexels-photo-1148820.jpeg"
  },
  {
    id: 3,
    title: "Segurança da Informação: Protegendo seus dados em 2025",
    excerpt: "As principais ameaças cibernéticas do momento e como proteger sua empresa contra ataques.",
    date: "2025-07-28",
    category: "Segurança",
    image: "https://images.pexels.com/photos/60504/security-protection-anti-virus-software-60504.jpeg"
  }
];

export const blogCategories = [
  "Suporte TI",
  "Cloud",
  "Segurança",
  "Infraestrutura",
  "Consultoria"
];

export const images = {
  hero: "https://images.pexels.com/photos/1089438/pexels-photo-1089438.jpeg",
  about: "https://images.pexels.com/photos/1181354/pexels-photo-1181354.jpeg",
  services: "https://images.pexels.com/photos/845451/pexels-photo-845451.jpeg",
  cloud: "https://images.pexels.com/photos/1148820/pexels-photo-1148820.jpeg",
  network: "https://images.pexels.com/photos/442150/pexels-photo-442150.jpeg",
  security: "https://images.pexels.com/photos/60504/security-protection-anti-virus-software-60504.jpeg"
};

export const aboutPage = {
  hero: {
    badge: "Quem Somos",
    title: "Conheça a",
    highlight: "DRSUPORTI",
    description:
      "Somos uma empresa de Soluções em TI com foco em atender empresas que não podem parar. Nossa missão é garantir que sua tecnologia funcione de forma eficiente, segura e sem interrupções."
  },
  intro: {
    title: "Tecnologia que faz sua empresa crescer",
    paragraphs: [
      "A DRSUPORTI nasceu da percepção de que muitas empresas enfrentam dificuldades com sua infraestrutura de TI, seja por falta de pessoal qualificado, problemas recorrentes ou dificuldade em acompanhar a evolução tecnológica.",
      "Ao longo dos anos, construímos uma equipe de profissionais certificados e apaixonados por tecnologia, prontos para atender desde demandas simples até projetos complexos de infraestrutura.",
      "Hoje, atendemos empresas de diversos portes e segmentos nos estados do Maranhão, Piauí e São Paulo, sempre com o compromisso de oferecer soluções personalizadas e atendimento de excelência."
    ],
    stats: [
      { icon: "MapPin", label: "MA, PI e SP" },
      { icon: "Users", label: "500+ Clientes" }
    ]
  },
  video: {
    badge: "Vídeo Institucional",
    title: "Conheça a DRSUPORTI por dentro",
    description: "Veja como trabalhamos para manter sua empresa sempre operando",
    coverUrl: images.services,
    videoUrl: ""
  },
  differentialsSection: {
    badge: "Por que a DRSUPORTI",
    title: "Nossos Diferenciais"
  },
  pillars: {
    badge: "Nossos Pilares",
    title: "Missão, Visão e Valores",
    items: [
      {
        icon: "Target",
        title: "Missão",
        description:
          "Oferecer soluções de TI de excelência que permitam nossos clientes focarem em seu core business, com a tranquilidade de ter sua tecnologia em boas mãos."
      },
      {
        icon: "Eye",
        title: "Visão",
        description:
          "Ser reconhecida como a principal referência em soluções de TI nos estados onde atuamos, conhecida pela qualidade, agilidade e compromisso com resultados."
      },
      {
        icon: "Heart",
        title: "Valores",
        description:
          "Compromisso com o cliente, excelência técnica, transparência nas relações, inovação contínua e respeito às pessoas."
      }
    ]
  },
  timeline: {
    badge: "Nossa História",
    title: "Uma trajetória de sucesso",
    items: [
      {
        year: "2015",
        title: "Fundação",
        description: "Início das atividades com foco em suporte técnico para pequenas empresas."
      },
      {
        year: "2017",
        title: "Expansão de Serviços",
        description: "Ampliamos para infraestrutura de redes e segurança da informação."
      },
      {
        year: "2019",
        title: "Cloud Computing",
        description: "Parceria com principais provedores de nuvem: AWS, Azure e Google Cloud."
      },
      {
        year: "2021",
        title: "Expansão Regional",
        description: "Atendimento expandido para os estados de MA, PI e SP."
      },
      {
        year: "2023",
        title: "Consultoria Estratégica",
        description: "Lançamento do serviço de consultoria e melhoria de processos de TI."
      },
      {
        year: "2025",
        title: "Hoje",
        description: "Mais de 500 clientes atendidos e equipe de especialistas certificados."
      }
    ]
  },
  cta: {
    title: "Quer saber mais sobre a DRSUPORTI?",
    description:
      "Entre em contato e conheça nossas soluções personalizadas para sua empresa.",
    primaryLabel: "Fale com um especialista",
    secondaryLabel: "Ver formas de contato",
    secondaryHref: "/contato"
  }
};

export const contactPage = {
  hero: {
    badge: "Contato",
    title: "Fale com a",
    highlight: "DRSUPORTI",
    description:
      "Estamos prontos para atender sua empresa. Entre em contato e descubra como podemos ajudar."
  },
  cards: {
    items: [
      {
        icon: "Phone",
        title: "Telefone",
        value: companyInfo.phone,
        link: `tel:${companyInfo.phone}`,
        description: "Ligue para nós"
      },
      {
        icon: "Mail",
        title: "E-mail",
        value: companyInfo.email,
        link: `mailto:${companyInfo.email}`,
        description: "Envie um e-mail"
      },
      {
        icon: "MessageCircle",
        title: "WhatsApp",
        value: "Fale conosco",
        link: `https://wa.me/${companyInfo.whatsapp}`,
        description: "Atendimento rápido"
      },
      {
        icon: "MapPin",
        title: "Atuação",
        value: "MA, PI e SP",
        link: "",
        description: "Atendimento presencial e remoto"
      }
    ]
  },
  form: {
    badge: "Formulário de Contato",
    title: "Envie sua mensagem",
    description:
      "Preencha o formulário abaixo e nossa equipe entrará em contato em até 24 horas úteis.",
    submitLabel: "Enviar mensagem",
    sendingLabel: "Enviando...",
    fields: {
      name: "Seu nome",
      email: "Seu e-mail",
      company: "Nome da empresa",
      phone: "Telefone",
      subject: "Assunto",
      message: "Sua mensagem"
    }
  },
  whatsappCta: {
    title: "Prefere atendimento imediato?",
    description:
      "Fale diretamente com um de nossos especialistas pelo WhatsApp e receba atendimento personalizado em tempo real.",
    buttonLabel: "Fale com um especialista"
  },
  hours: {
    title: "Horário de atendimento",
    lines: ["Segunda a Sexta: 08h às 18h", "Sábado: 08h às 12h"],
    highlight: "Chamados críticos: 24/7"
  },
  coverage: {
    title: "Área de Atuação",
    description:
      "Atendemos empresas nos estados do Maranhão, Piauí e São Paulo, com suporte presencial e remoto.",
    states: ["Maranhão", "Piauí", "São Paulo"]
  }
};

export const faqs = [
  {
    question: "Quais regiões a DRSUPORTI atende?",
    answer: "Atendemos empresas nos estados do Maranhão (MA), Piauí (PI) e São Paulo (SP), com suporte presencial e remoto."
  },
  {
    question: "Como funciona o suporte técnico?",
    answer: "Oferecemos suporte remoto e presencial, com diferentes níveis de SLA conforme a necessidade da sua empresa. Nossa equipe está disponível para atender chamados críticos 24/7."
  },
  {
    question: "Qual o tempo de resposta para chamados?",
    answer: "Nosso tempo de primeira resposta varia de 15 minutos a 2 horas, dependendo do plano contratado e criticidade do chamado."
  },
  {
    question: "Vocês oferecem contrato de manutenção preventiva?",
    answer: "Sim! Oferecemos contratos de manutenção preventiva que incluem visitas periódicas, monitoramento contínuo e atualizações de segurança."
  },
  {
    question: "Como posso solicitar um orçamento?",
    answer: "Entre em contato pelo WhatsApp, telefone ou formulário do site. Nossa equipe comercial retornará em até 24 horas úteis."
  }
];


export const defaultSiteContent = {
  companyInfo,
  services,
  differentials,
  testimonials,
  blogPosts,
  blogCategories,
  aboutPage,
  contactPage,
  institutionalVideo: {
    coverUrl: images.about,
    videoUrl: "",
    durationLabel: "1:30"
  },
  faqs,
  images
};
